var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.375V0H1.125C0.501562 0 0 0.501562 0 1.125V22.875C0 23.4984 0.501562 24 1.125 24H16.875C17.4984 24 18 23.4984 18 22.875V7.5H11.625C11.0063 7.5 10.5 6.99375 10.5 6.375ZM14.0836 16.2825L9.56391 20.7684C9.25219 21.0783 8.74875 21.0783 8.43703 20.7684L3.91734 16.2825C3.44156 15.8105 3.77531 15 4.44469 15H7.5V11.25C7.5 10.8356 7.83563 10.5 8.25 10.5H9.75C10.1644 10.5 10.5 10.8356 10.5 11.25V15H13.5553C14.2247 15 14.5584 15.8105 14.0836 16.2825ZM17.6719 4.92188L13.0828 0.328125C12.8719 0.117188 12.5859 0 12.2859 0H12V6H18V5.71406C18 5.41875 17.8828 5.13281 17.6719 4.92188Z",
    fill: "#AEFEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_73"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownload);
export default __webpack_public_path__ + "static/media/file-download.2395a644183ae13c557989ef7a12ea28.svg";
export { ForwardRef as ReactComponent };